module.exports = __webpack_public_path__ + "img/Solidworks_Step_4.81222ce7.png";